import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createCircleNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;

const STICK1_TOP_Y = -10;
const STICK1_MIDDLE_Y = -9;
const STICK1_BOTTOM_Y = -8;
const STICK2_TOP_Y = -1;
const STICK2_MIDDLE_Y = 0;
const STICK2_BOTTOM_Y = 1;
const STICK3_TOP_Y = 8;
const STICK3_MIDDLE_Y = 9;
const STICK3_BOTTOM_Y = 10;
const STICKS_START_X = -8;
const STICKS_END_LEFT_X = 5.6;
const STICKS_END_RIGHT_X = 7.6;
const STICKS_CUTOUT_X = -7;
const MAIN_ARROW_BASE_X = 11.6;
const MAIN_ARROW_TIP_X = 17.2;
const MAIN_ARROW_TOP_Y = -4.4;
const MAIN_ARROW_BOTTOM_Y = 4.4;
const LEFT_TRIANGLE_LEFT = -12.8;
const LEFT_TRIANGLE_RIGHT = -8.4;
const LEFT_TRIANGLE_HALF_HEIGHT = 3.6;

const drawLeftTriangle = (builder: SvgPathBuilder, y: number) => {
  builder
    .moveTo(LEFT_TRIANGLE_LEFT, y - LEFT_TRIANGLE_HALF_HEIGHT)
    .vLineTo(y + LEFT_TRIANGLE_HALF_HEIGHT)
    .lineTo(LEFT_TRIANGLE_RIGHT, y)
    .close();
};

function createCloudNatGwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const poseidonStickBuilder = new SvgPathBuilder()
    .moveTo(STICKS_START_X, STICK1_TOP_Y)
    .hLineTo(STICKS_END_RIGHT_X)
    .vLineTo(STICK2_TOP_Y)
    .hLineTo(MAIN_ARROW_BASE_X)
    .vLineTo(MAIN_ARROW_TOP_Y)
    .lineTo(MAIN_ARROW_TIP_X, 0)
    .lineTo(MAIN_ARROW_BASE_X, MAIN_ARROW_BOTTOM_Y)
    .vLineTo(STICK2_BOTTOM_Y)
    .hLineTo(STICKS_END_RIGHT_X)
    .vLineTo(STICK3_BOTTOM_Y)
    .hLineTo(STICKS_START_X)
    .lineTo(STICKS_CUTOUT_X, STICK3_MIDDLE_Y)
    .lineTo(STICKS_START_X, STICK3_TOP_Y)
    .hLineTo(STICKS_END_LEFT_X)
    .vLineTo(STICK2_BOTTOM_Y)
    .hLineTo(STICKS_START_X)
    .lineTo(STICKS_CUTOUT_X, STICK2_MIDDLE_Y)
    .lineTo(STICKS_START_X, STICK2_TOP_Y)
    .hLineTo(STICKS_END_LEFT_X)
    .vLineTo(STICK1_BOTTOM_Y)
    .hLineTo(STICKS_START_X)
    .lineTo(STICKS_CUTOUT_X, STICK1_MIDDLE_Y)
    .close();

  drawLeftTriangle(poseidonStickBuilder, STICK1_MIDDLE_Y);
  drawLeftTriangle(poseidonStickBuilder, STICK2_MIDDLE_Y);
  drawLeftTriangle(poseidonStickBuilder, STICK3_MIDDLE_Y);

  const icon = `${drawCircleBackground(DIAMETER / 2, opts.style)}
    ${makeTag('path', {
      d: poseidonStickBuilder.build(),
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
    })}
  `;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const cloudNatGwIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createCloudNatGwIcon,
);
